import EventBus from "@/services/eventBus";
import Message from "../../message";
import ReferenceManager from "@/services/referenceManager";

export default class ReferenceFile extends Message
{
    handle()
    {
        ReferenceManager.get(this.message.reference_id)
            .catch(() => {
                EventBus.emit('error-fatal', 'Reference Manager Error');
            });
    }
}
